module.exports = __webpack_public_path__ + "img/04智慧物流.fd56aa22.jpg";